// ReSharper disable InconsistentNaming
define(['jquery', 'events'], function ($, events) {
    'use strict';

    function triggerDownload(attachmentId) {
        // if not iOS, then download in the background, otherwise open a window with the file
        var iOS = !!navigator.userAgent.match('iPhone OS') || !!navigator.userAgent.match('iPad');
        if (!iOS) {
            $.get('/attachment/check-download/' + attachmentId)
                .fail(function () {
                    events.trigger('show-attachment-unavailable');
                })
                .success(function () {
                    $('body').append('<iframe style="display:none" src="/attachment/getfile/' + attachmentId + '" />');
                });
        }
        else {
            window.open('/attachment/getfile/' + attachmentId);
        }
    }

    return triggerDownload;
});